import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=3f6cf1c6&scoped=true&lang=pug"
import script from "./ClientList.vue?vue&type=script&lang=js"
export * from "./ClientList.vue?vue&type=script&lang=js"
import style0 from "./ClientList.vue?vue&type=style&index=0&id=3f6cf1c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6cf1c6",
  null
  
)

export default component.exports